<template lang="pug">
.container
  .row
    h2.main_title FAQ
      .pull-right(style="display: flex; align-items: center;")
        input.form-control(v-model="temporarySearchQuery" @keydown.enter="applySearchQuery" placeholder="Search..." style="width: auto;")
    .col-md-12
      .faq-list
        .faq-item(v-for="item in filteredFaqs" @click="toggle(item)")
          .faq-question
            span.toggle-icon
              span.glyphicon(:class="isItemExpanded(item) ? 'glyphicon-chevron-down' : 'glyphicon-chevron-right'")
            span.question-text(v-html="highlightMatches(item.question, searchQuery)")
          .faq-answer(v-show="isItemExpanded(item)" @click.stop v-html="highlightMatches(item.answer, searchQuery)")
        .faq-empty(v-if="filteredFaqs.length === 0")
          | No results found.
</template>

<script>
import { store } from '../../index.js'
import searchMixin from '../../mixins/searchMixin.js'

const faqs = [
  {
    question: 'How do I download firmware?',
    answer: 'Navigate to the Switch > Firmware page. Use the category and status filters to find the firmware you need, then click the download button next to the version.'
  },
  {
    question: 'How do I download a Private MIB?',
    answer: 'Navigate to Switch > Private MIB. Select the product family and version, then click Download.'
  },
  {
    question: 'What is the InstaViewer page?',
    answer: 'The InstaViewer page shows firmware and upgrade guides specifically for InstaViewer category devices.'
  },
  {
    question: 'How do I reset my password?',
    answer: 'Click on your email in the top-right corner of the navbar and select Change Password.'
  }
]

export default {
  mixins: [searchMixin],
  data () {
    return {
      temporarySearchQuery: '',
      searchQuery: '',
      faqs: faqs.map(f => ({ ...f, expanded: false }))
    }
  },
  computed: {
    user () {
      return store.state.user
    },
    filteredFaqs () {
      const q = this.searchQuery.trim().toLowerCase()
      if (!q) return this.faqs
      return this.faqs.filter(f =>
        f.question.toLowerCase().includes(q) || f.answer.toLowerCase().includes(q)
      )
    }
  },
  methods: {
    toggle (item) {
      item.expanded = !item.expanded
    },
    isItemExpanded (item) {
      return item.expanded || this.searchQuery.trim() !== ''
    }
  }
}
</script>

<style scoped lang="scss">
.faq-list {
  margin-top: 16px;
}

.faq-item {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;

  &:hover .faq-question {
    background-color: #f0f0f0;
  }
}

.faq-question {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-radius: 4px;
  user-select: none;

  .toggle-icon {
    margin-right: 10px;
    color: #555;
    flex-shrink: 0;
  }

  .question-text {
    font-weight: 600;
    font-size: 14px;
  }
}

.faq-answer {
  padding: 14px 16px 14px 40px;
  font-size: 14px;
  color: #444;
  border-top: 1px solid #eee;
  line-height: 1.6;
  white-space: pre-wrap;
}

.faq-empty {
  color: #999;
  padding: 20px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// FAQ.vue?3d1f3a1e